import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog';
import { Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
import { AuErrorService } from '@core/services/au-error-service';
import { IconSnackBarService } from '@core/services/icon-snack-bar.service';
import { ISensorInstallation } from '@app/pages/settings/portfolio/interfaces/area-assets.interfaces';
import { AssetFinishSensorInstallationMutation } from '@app/pages/settings/portfolio/graphql/assets-graphql.queries';
import { SENSOR_SIGNAL_STRENGTH_THRESHOLD } from '@app/shared';
import { TranslateService, NgxTolgeeModule } from '@tolgee/ngx';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AuTechnoBtnComponent } from '../../../shared/ui-components/au-techno-btn/au-techno-btn.component';
import { MatRipple } from '@angular/material/core';

@Component({
	templateUrl: './confirm-sensor-installation-modal.component.html',
	styleUrls: ['./confirm-sensor-installation-modal.component.scss'],
	imports: [
		NgClass,
		MatIcon,
		MatDialogActions,
		AuTechnoBtnComponent,
		MatDialogClose,
		MatRipple,
		NgxTolgeeModule,
	],
})
export class ConfirmSensorInstallationModalComponent {
	sensorThreshold = SENSOR_SIGNAL_STRENGTH_THRESHOLD;

	constructor(
		@Inject(MAT_DIALOG_DATA) public modalData: { sensor: ISensorInstallation },
		private dialogRef: MatDialogRef<ConfirmSensorInstallationModalComponent>,
		private apollo: Apollo,
		private auErrorService: AuErrorService,
		private notify: IconSnackBarService,
		private translateService: TranslateService
	) {}

	confirmApproved() {
		this.apollo
			.mutate<{ success: boolean }>({
				mutation: AssetFinishSensorInstallationMutation,
				variables: {
					sensors: [
						{
							serial_number: this.modalData.sensor.serialNumber,
							sensor_type_id: this.modalData.sensor.sensorTypeId,
						},
					],
				},
			})
			.pipe(pluck('data', 'finishInstallation'))
			.subscribe({
				next: (res: { success: boolean }) => {
					this.afterSuccessMutation(res.success);
				},
				error: err => {
					this.afterErrorMutation(err);
				},
			});
	}

	afterSuccessMutation(success) {
		if (!success) {
			this.notify.error(
				this.translateService.instant('error_sensor_installation_confirm')
			);
		}

		this.dialogRef.close(true);
		this.notify.success(
			this.translateService.instant('success_sensor_installation_confirm')
		);
	}

	afterErrorMutation(error) {
		this.auErrorService.notifyUserAboutError({
			error,
			defaultMessage: 'Installation cannot be confirmed. Try again later',
		});
	}

	get signalStrength(): number {
		return this.modalData.sensor.rssi.lastSeenRssiInPercentage;
	}

	get minutesLastDataReceivedAgo(): number {
		return this.modalData.sensor.rssi.lastSeenInMinutes;
	}
}
